import TemplateNames from './TemplateNames';

export default {
  title: 'Automaattiset sähköpostit',
  labels: {
    empty_list: 'Malleja ei löytynyt',
    load_failed: 'Automaattisia sähköposteja ei voitu ladata. Lataa sivu uudelleen tai ota yhteyttä tukeen.',
    on: 'Päällä',
    off: 'Pois',
  },
  fields: {
    name: 'Nimi',
    messages_delivered: 'Viestejä toimitettu',
    open_rate: 'Avausprosentti',
    click_rate: 'Napsautusprosentti',
    status: 'Tila',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Tilan päivitys epäonnistui',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
